import { styled } from '@mui/styles';
import { Link, type Theme } from '@mui/material';

export const LinkWrapper = styled(Link)(({ theme, disabled }: { theme: Theme; disabled: boolean }) => ({
  color: disabled ? theme.palette.text.disabled : theme.palette.primary.main,
  cursor: disabled ? 'not-allowed' : 'pointer',
  pointerEvents: disabled ? 'none' : 'auto',
  fontWeight: 600,
  width: '100%',
  padding: '1rem 0',
  textAlign: 'left'
}));
